<div class="row row-head">
  <div *ngIf="page" class="title-label">
    <!-- <fa-icon [icon]="faQuestionCircle" class="icon-fa-question"></fa-icon> -->
    {{ page.title }}
  </div>
</div>
